import React, { useEffect, useState } from "react";
import { BtnWrapper } from "../../styles/Docs/DocsToolbar.styled";
import { useMediaQuery } from "react-responsive";
import ClearIcon from "@mui/icons-material/Clear";

import { CircularProgress } from "@mui/material";
import { AlertTooltip } from "../Spreadsheet/ModTooltip";
import { DoneIcon, Remove } from "../../../public/icons";

interface DeleteIconProps {
  state: 'idle' | 'loading' | 'success' | 'failure';
  disable: boolean;
}


const DeleteIcon = ({  disable, state }: DeleteIconProps) => {
  if (state === "loading") {
    return <CircularProgress sx={{ color: "var(--blue)" }} />;
  }
  if (state === "success") {
    return <DoneIcon />;
  }

if (state === "failure") {
    return <ClearIcon sx={{ color: "var(--vivid-pink)"}}/>;
  }
  return  <Remove size={"76%"} color={disable ? "var(--disabled-c)" :"var(--blue)"} />
};


interface DeleteButtonProps {
  state: 'idle' | 'loading' | 'success' | 'failure';
  size?: number | string;
  onClick:  ()=> void;
  single?: boolean;
  error?: string;
  disable?: boolean;
}

export default function DeleteButton({
  single = false,
  state,
  error,
  disable,
  onClick
}: DeleteButtonProps) {    
    const [tooltipOpen, setTooltipOpen] = useState(false);
    const isMobile = useMediaQuery({ maxWidth: 991 });

useEffect(() => {
    if (state === "failure") {
      setTooltipOpen(true);

      const timer = setTimeout(() => {
        setTooltipOpen(false);
      }, 3000);

      return () => clearTimeout(timer);
    }
    
    if (state === "success") {
      setTooltipOpen(true);
    }

    if (state === "idle") {
      setTooltipOpen(false);
    }
  }, [state]);

const onClose = () => {
    if (state === "idle") {
      setTooltipOpen(false);
    }
  };

  const disabled =
   disable || state === "loading";

  const getTooltipTitle = () => {
        if (state === "idle") return `Видалити ${single ? "документ" : "документи"}`;

    if (state === "failure") return error ?  error : `Помилка видалення ${single ? "документа" : "документів"} `;
    if (state === "success")
      return "Видалено";
  };


const onHover = () => {
    if (!isMobile && state === "idle") {
      setTooltipOpen(true);
    }
  };

  return (
    <React.Fragment>
      <AlertTooltip
        open={tooltipOpen}
        id={
          state === "failure"
            ? "failure"
            : state === "success"
              ? "success"
              : "idle"
        }
        title={getTooltipTitle()}
      >
        <span>
          <BtnWrapper
            $bgColor={state === "failure" ? "rgba(255, 0, 127, 0.15)" :  "var(--sidebar-hover)"}
            $color={"var(--white)"}
            onClick={onClick}
            onMouseEnter={onHover}
            onMouseLeave={onClose}
            disabled={disabled}
          >
            <DeleteIcon  disable={disabled} state={state}/>
          </BtnWrapper>
        </span>
      </AlertTooltip>
    </React.Fragment>
  );
}
